import React from 'react';
import { PaymentError, StatusPhase, StepStatusCaseData } from '@/interfaces';
import { AccordionElement } from '../container-phase';
import { getStatusStep, getStep } from '@/lib';
import { PaymentDetails } from './payment-details';
import { SettlementDetailsForm } from './settlement-details/';
import { useQuery } from '@tanstack/react-query';
import {
	casesLawyerService,
	GET_SETTLEMENT_DETAILS,
	GET_SETTLEMENT_SUMMARY,
} from '@/api';
import { Typography } from '@/components/common';
import { CaseContext } from '@/context/CaseContext';

interface Props {
	caseSteps: StepStatusCaseData | undefined;
	casePhase: StatusPhase | undefined;
	currentOpenStep: string[] | undefined;
	casesErrors: PaymentError[];
	setCurrentOpenStep: React.Dispatch<
		React.SetStateAction<string[] | undefined>
	>;
}

export const SettlementPhase: React.FC<Props> = ({
	casePhase,
	caseSteps,
	currentOpenStep,
	setCurrentOpenStep,
	casesErrors,
}) => {
	const { caseDetails } = React.useContext(CaseContext);
	const [isErrorMessage, setIsErrorMessage] = React.useState<boolean>(false);

	const { data: settlementDetail, refetch: refetchSettlement } = useQuery({
		queryKey: [GET_SETTLEMENT_DETAILS, caseDetails],
		queryFn: () =>
			casesLawyerService.caseSettlementDetail(caseDetails?.id as string),
		enabled: !!caseDetails,
	});

	const { data: settlementSummary } = useQuery({
		queryKey: [GET_SETTLEMENT_SUMMARY, caseDetails?.id],
		queryFn: () =>
			casesLawyerService.getSettlementSummary(caseDetails?.id as string),
		enabled: !!caseDetails,
	});

	return (
		<>
			<AccordionElement
				id="1"
				label="Settlement Details"
				step="Settlement Details"
				phase={casePhase}
				statusStep={getStatusStep('Settlement Details', casePhase?.steps)}
				setIsErrorMessage={setIsErrorMessage}
				isErrorMessage={isErrorMessage}
				currentOpenStep={currentOpenStep}
				setCurrentOpenStep={setCurrentOpenStep}
			>
				<SettlementDetailsForm
					caseSteps={caseSteps}
					caseDetails={caseDetails}
					settlementDetail={settlementDetail}
					refetchDetails={refetchSettlement}
					stepCase={getStep('Settlement Details', casePhase?.steps)}
					statusStep={getStatusStep('Settlement Details', casePhase?.steps)}
				/>
			</AccordionElement>
			<AccordionElement
				id="2"
				label="Payment Details"
				// step="Payment Details"
				phase={casePhase}
				statusStep={getStatusStep('Payment Details', casePhase?.steps)}
				setIsErrorMessage={setIsErrorMessage}
				isErrorMessage={isErrorMessage}
				currentOpenStep={currentOpenStep}
				setCurrentOpenStep={setCurrentOpenStep}
				accordionContentClassName={
					currentOpenStep?.includes('Payment Details')
						? '!overflow-y-visible'
						: ''
				}
				accordionContainerClassName={
					currentOpenStep?.includes('Payment Details')
						? '!overflow-visible'
						: ''
				}
			>
				<PaymentDetails
					caseSteps={caseSteps}
					settlementDetail={settlementDetail}
					settlementSummary={settlementSummary?.data}
					refetchSettlement={refetchSettlement}
					statusStep={getStatusStep('Payment Details', casePhase?.steps)}
				/>
			</AccordionElement>
			{casesErrors.map((error, index) => {
				const message = error.error_message;
				return (
					<div key={index} className="flex items-center gap-1">
						<Typography type="regular-16" className="text-main-red">
							{message}
						</Typography>
					</div>
				);
			})}
		</>
	);
};

// import React from 'react';
// import {
// 	CaseDetailsLawyer,
// 	PaymentError,
// 	StatusPhase,
// 	StepStatusCaseData,
// } from '@/interfaces';
// import { AccordionElement, ContainerPhase } from '../container-phase';
// import { getStatusPhase, getStatusStep, getStep } from '@/lib';

// import { PaymentDetails } from './payment-details';
// import { SettlementDetailsForm } from './settlement-details/';
// import { useQuery } from '@tanstack/react-query';
// import { casesLawyerService, GET_SETTLEMENT_DETAILS } from '@/api';
// import { Typography } from '@/components/common';

// interface Props {
// 	caseDetails: CaseDetailsLawyer | undefined;
// 	caseSteps: StepStatusCaseData | undefined;
// 	casePhase: StatusPhase | undefined;
// 	currentOpenStep: string | undefined;
// 	casesErrors: PaymentError[];
// 	setCurrentOpenStep: React.Dispatch<React.SetStateAction<string | undefined>>;
// }

// export const SettlementPhase: React.FC<Props> = ({
// 	caseDetails,
// 	casePhase,
// 	caseSteps,
// 	currentOpenStep,
// 	setCurrentOpenStep,
// 	casesErrors,
// }) => {
// 	const [isErrorMessage, setIsErrorMessage] = React.useState<boolean>(false);
// 	const { data: settlementDetail, refetch: refetchSettlement } = useQuery({
// 		queryKey: [GET_SETTLEMENT_DETAILS, caseDetails],
// 		queryFn: () =>
// 			casesLawyerService.caseSettlementDetail(caseDetails?.id as string),
// 		enabled: !!caseDetails,
// 	});

// 	return (
// 		<ContainerPhase
// 			title="Settlement Phase"
// 			caseDetails={caseDetails}
// 			setIsErrorMessage={setIsErrorMessage}
// 			statusPhase={getStatusPhase({ steps: casePhase?.steps })}
// 			phaseSteps={casePhase?.steps}
// 			settlementDetail={settlementDetail?.data}
// 			phaseData={caseSteps?.status}
// 			hasPaymentError={casesErrors.length > 0}
// 		>
// 			<AccordionElement
// 				label="Settlement Details"
// 				phase={casePhase}
// 				statusStep={getStatusStep('Settlement Details', casePhase?.steps)}
// 				setIsErrorMessage={setIsErrorMessage}
// 				isErrorMessage={isErrorMessage}
// 				currentOpenStep={currentOpenStep}
// 				setCurrentOpenStep={setCurrentOpenStep}
// 			>
// 				<SettlementDetailsForm
// 					caseSteps={caseSteps}
// 					caseDetails={caseDetails}
// 					settlementDetail={settlementDetail}
// 					refetchDetails={refetchSettlement}
// 					stepCase={getStep('Settlement Details', casePhase?.steps)}
// 					statusStep={getStatusStep('Settlement Details', casePhase?.steps)}
// 				/>
// 			</AccordionElement>
// 			<AccordionElement
// 				label="Payment Details"
// 				phase={casePhase}
// 				statusStep={getStatusStep('Payment Details', casePhase?.steps)}
// 				setIsErrorMessage={setIsErrorMessage}
// 				isErrorMessage={isErrorMessage}
// 				currentOpenStep={currentOpenStep}
// 				setCurrentOpenStep={setCurrentOpenStep}
// 			>
// 				<PaymentDetails
// 					caseDetails={caseDetails}
// 					caseSteps={caseSteps}
// 					settlementDetail={settlementDetail}
// 					refetchSettlement={refetchSettlement}
// 					statusStep={getStatusStep('Payment Details', casePhase?.steps)}
// 				/>
// 			</AccordionElement>
// 			{casesErrors.map((error, index) => {
// 				const message = error.error_message;
// 				return (
// 					<div key={index} className="flex items-center gap-1">
// 						<Typography type="regular-16" className="text-main-red">
// 							{message}
// 						</Typography>
// 					</div>
// 				);
// 			})}
// 		</ContainerPhase>
// 	);
// };
